/* ---- Tap feedback: "selected" state for touch ----------------------------

   Hover is a mouse idea. On a phone there is no hover, so a tappable card
   either gives no feedback at all or -- on several Android builds -- keeps
   :hover latched on whatever you tapped last until you tap something else.
   Both were visible on the category tiles: tapping HEADQUARTERS left its
   label orange for the rest of the session while the other three stayed
   white.

   CSS handles the press itself via :active. What CSS cannot do is hold the
   color across the gap between finger-up and the next page painting --
   :active ends the instant you lift, and on a phone that is well before
   the new page appears, so the tap reads as ignored. This adds a class on
   pointerdown and deliberately never removes it; the navigation tears the
   DOM down for us.

   pointerdown rather than click: it fires on contact instead of release,
   so the feedback is immediate, and it covers mouse, touch and pen in one
   listener.

   Deliberately NOT merged with the identical handling for the mobile nav
   links in header.js: that one is scoped to the panel element and is bound
   up with the scroll-lock/bfcache logic around it. Two small handlers with
   clear owners beat one shared handler that needs to know about both.
--------------------------------------------------------------------------*/
(function () {
  "use strict";

  var SELECTOR = ".collection-tile:not(.is-disabled)";

  document.addEventListener("pointerdown", function (e) {
    var el = e.target.closest ? e.target.closest(SELECTOR) : null;
    if (!el) return;
    // Clear any previously lit sibling. Without this, a same-page anchor or
    // a link that fails to navigate leaves two tiles lit at once, since
    // nothing ever removes the class.
    var prev = document.querySelector(".collection-tile.is-selected");
    if (prev && prev !== el) prev.classList.remove("is-selected");
    el.classList.add("is-selected");
  });

  /* Back button on iOS/Android restores the page from bfcache exactly as it
     was left -- including the tile we lit on the way out, which now points
     at a page the user has already come back from. */
  window.addEventListener("pageshow", function (e) {
    if (!e.persisted) return;
    var lit = document.querySelectorAll(".collection-tile.is-selected");
    for (var i = 0; i < lit.length; i++) lit[i].classList.remove("is-selected");
  });
})();
